import React from 'react'
import PropTypes from 'prop-types'

import { push } from 'react-router-redux'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { familyAlbumFiltersSet } from 'Global/Stores/familyAlbum'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    filters: selectors.filters(state),
    query: selectors.query(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    redirectToSearch: email => dispatch(push(`/familyAlbum/search?email=${email}`)),
    setFilters: filters => dispatch(familyAlbumFiltersSet(filters)),
  })

  Enhancer.displayName = 'FASearchFormEnhancer'

  Enhancer.propTypes = {
    filters: PropTypes.object.isRequired,
    query: PropTypes.object,
    redirectToSearch: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
